module.exports = __webpack_public_path__ + "img/solenoid-dosing-pump.396ade8d.png";